import React from 'react';
import { Button } from '@/components/ui/button'; // Assuming ShadCN button
import { useAppStore } from '@/hooks/useAppStore';

export const ReconnectOverlay: React.FC = () => {
	const connectWebSocket = useAppStore((state) => state.connectWebSocket);
	const roomId = useAppStore((state) => state.roomId);

	const handleReconnect = () => {
		// Attempt to reconnect using the last known room ID
		// connectWebSocket handles fetching a new session if needed
		connectWebSocket(roomId);
	};

	// Or simply reload the page:
	// const handleReload = () => window.location.reload();

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-neutral-900/90">
			<div className="text-center">
				<Button
					onClick={handleReconnect} // Or handleReload
					variant="destructive" // Or another appropriate variant
					size="lg"
					className="rounded-full w-48 h-48 flex flex-col items-center justify-center p-4 animate-pulse" // Style as needed
				>
					<span className="font-semibold uppercase text-lg">
						タップして再参加
						<br />
						Tap to Reconnect!
					</span>
				</Button>
			</div>
		</div>
	);
};
